import cfac22 from "../library/utils/cfac22/cfac22";

export function startMatomo() {
  var _paq = (window._paq = window._paq || []);
  const u = "https://matomo.triibo.com.br/";
  const trackerScriptUrl = u + "matomo.js";
  const trackerAlreadyInserted = document.querySelector(`script[src="${trackerScriptUrl}"]`);

  if (!trackerAlreadyInserted) {
    _paq.push(["setTrackerUrl", u + "matomo.php"]);
    _paq.push(["setSiteId", cfac22("idMatomo")]);
    _paq.push(["enableLinkTracking"]);

    var d = document,
      g = d.createElement("script"),
      s = d.getElementsByTagName("script")[0];
    g.type = "text/javascript";
    g.async = true;
    g.src = trackerScriptUrl;
    s.parentNode.insertBefore(g, s);
  }
}

export function setMatomoUserId(userId) {
  var _paq = (window._paq = window._paq || []);
  _paq.push(["setUserId", userId]);
}

export function resetMatomoUserId() {
  var _paq = (window._paq = window._paq || []);
  _paq.push(["resetUserId"]);
}

export function trackEventMatomo(location, event, element, elementName) {
  const elementType = `element:${element}; elementName:${elementName}`;

  var _paq = (window._paq = window._paq || []);
  _paq.push(["trackEvent", location, event, elementType]);
}

export function trackEventMatomoElementId(location, event, element, elementId) {
  const elementType = `element:${element}; elementId:${elementId}`;

  var _paq = (window._paq = window._paq || []);
  _paq.push(["trackEvent", location, event, elementType]);
}

export function trackEventMatomoVisit(locationName) {
  var _paq = (window._paq = window._paq || []);
  _paq.push(["trackEvent", locationName, "visualizar", window.location.href, 0]);
}
